import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarClock, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { fmtDate, fmtDateTime } from "@/lib/format";

// Qué pasa con el nivel al empezar un año nuevo. Durante el año el nivel alcanzado no baja.
export function TierPolicyCard() {
  const [data, setData] = useState<any>(null);
  const [mode, setMode] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/tier-policy").then((r) => { setData(r.data); setMode(r.data.mode); }).catch(() => setData(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data: r } = await api.put("/admin/tier-policy", { mode });
      setData({ ...data, ...r });
      toast.success("Política guardada: se aplicará al iniciar el próximo año.");
    } catch (e) { toast.error(apiError(e)); }
    finally { setSaving(false); }
  };

  if (data === false) return null;
  return (
    <section className="card-obsidian p-6 space-y-4" aria-labelledby="tier-policy-title" data-testid="tier-policy">
      <div className="flex items-start gap-3">
        <span className="w-10 h-10 rounded-full bg-navy/10 text-navy flex items-center justify-center shrink-0"><CalendarClock className="w-5 h-5" aria-hidden="true" /></span>
        <div>
          <h2 id="tier-policy-title" className="text-lg font-semibold">Periodo de los niveles</h2>
          <p className="text-sm text-slate-600 max-w-3xl">
            El periodo es el año calendario. Durante el año, cada cliente <strong>conserva el nivel más alto que alcanzó</strong>: canjear puntos,
            el vencimiento del saldo o un cambio de umbrales no lo bajan. Sube en cuanto sus puntos ganados en el año llegan al mínimo de un nivel superior.
          </p>
        </div>
      </div>
      {!data ? (
        <div className="flex justify-center py-4" role="status"><Loader2 className="w-5 h-5 animate-spin text-navy" aria-hidden="true" /><span className="sr-only">Cargando…</span></div>
      ) : (
        <>
          <fieldset>
            <legend className="text-sm font-semibold text-slate-800 mb-2">Al empezar el año ({fmtDate(`${data.next_period_start}T12:00:00`)})…</legend>
            <div className="space-y-2">
              {data.modes.map((m: any) => (
                <label key={m.key} className={`flex items-start gap-2 p-3 rounded-lg border cursor-pointer text-sm ${mode === m.key ? "border-navy bg-navy/5" : "border-slate-200 hover:bg-slate-50"}`}>
                  <input type="radio" name="tier-mode" value={m.key} checked={mode === m.key} onChange={() => setMode(m.key)} className="mt-0.5 accent-navy" data-testid={`tier-mode-${m.key}`} />
                  <span>{m.label}</span>
                </label>
              ))}
            </div>
          </fieldset>
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="text-xs text-slate-600">
              En todos los casos, los puntos ganados en el año vuelven a cero y los niveles fijados a mano se liberan. El saldo para canjear vence aparte.
              {data.updated_by && <> Último cambio: {data.updated_by}, {fmtDateTime(data.updated_at)}.</>}
            </p>
            <Button onClick={save} disabled={saving || mode === data.mode} className="gold-gradient-bg text-white rounded-full" data-testid="tier-policy-save">
              {saving ? <Loader2 className="w-4 h-4 animate-spin" aria-label="Guardando" /> : "Guardar"}
            </Button>
          </div>
        </>
      )}
    </section>
  );
}
